import { render, staticRenderFns } from "./BanOperator.vue?vue&type=template&id=76d1b747&scoped=true&"
import script from "./BanOperator.vue?vue&type=script&lang=js&"
export * from "./BanOperator.vue?vue&type=script&lang=js&"
import style0 from "./BanOperator.vue?vue&type=style&index=0&id=76d1b747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d1b747",
  null
  
)

export default component.exports